import { render, staticRenderFns } from "./MDTextEditorDialog.vue?vue&type=template&id=4034832b&"
import script from "./MDTextEditorDialog.vue?vue&type=script&lang=js&"
export * from "./MDTextEditorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports